<template>
  <div id="app">
    <!-- Le contenu de chaque route sera injecté ici -->
    <router-view></router-view>
  </div>
</template>

<script setup>
// Rien de spécial ici pour le moment
</script>

<style scoped>
/* Ajoutez vos styles globaux ici si nécessaire */
</style>
